import { useTranslation } from "react-i18next";
import { BackLinkGridStyled, GridStyled, OuterGridStyled } from "./styles";

export default function BacklinkComponent(props) {
  const { cmsSpecialisations, cmsLocations } = props;
  const { t } = useTranslation();

  return cmsSpecialisations || cmsLocations ? (
    <OuterGridStyled
      container
      flexWrap={"wrap"}
      columnGap={"48px"}
      justifyContent={"center"}
      alignItems={"center"}
    >
      <GridStyled container maxWidth={"1440px"}>
        <BackLinkGridStyled
          container
          columnGap={"15px"}
          rowGap={"15px"}
          alignContent={"flex-start"}
        >
          <GridStyled container>
            <span>{t("footer.jobs_by_specialisation")}</span>
          </GridStyled>
          {cmsSpecialisations?.map((spec) => (
            <a
              href={`/jobs-in-${spec?.attributes.slug}`}
              key={`${spec?.attributes.slug}-button`}
            >
              {spec?.attributes?.name ?? "-"}
            </a>
          ))}
        </BackLinkGridStyled>
        <BackLinkGridStyled
          container
          columnGap={"15px"}
          rowGap={"15px"}
          alignContent={"flex-start"}
        >
          <GridStyled container>
            <span>{t("footer.jobs_by_location")}</span>
          </GridStyled>
          {cmsLocations?.map((loc) => (
            <a
              href={`/jobs-in-${loc?.attributes?.slug}`}
              key={`${loc?.attributes?.slug}-button`}
            >
              {loc?.attributes?.location ?? "-"}
            </a>
          ))}
        </BackLinkGridStyled>
      </GridStyled>
    </OuterGridStyled>
  ) : null;
}
